import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '../CookieAuth/auth.service';
import { Permiso } from '../interfaces/permisos';
import { Usr } from '../interfaces/usr';
import { ConfHttpService } from './conf-http.service';

@Injectable({
  providedIn: 'root'
})

export class UsuarioService {
  endpopint:string='';
  usr?:Usr[];
  headers:HttpHeaders = new HttpHeaders({'Content-Type': 'application/json'});
  constructor(private http:HttpClient, private cookie: AuthService, conf:ConfHttpService) {
    this.headers= new HttpHeaders({'Content-Type': 'application/json'});
    this.endpopint=conf.getBackend();
   }

   get()
  {
  return this.http.get<Usr[]>(this.endpopint+'usr');
  }
  getById(id:number)
  {
  return this.http.get<Usr>(this.endpopint+'usrbyid/'+id);
  }
  post(usuario:Usr, permiso:Permiso[]){
    usuario.token=this.cookie.getCookie();
    console.log(usuario)
    let id= this.http.post<number>(this.endpopint+'usr',usuario ,{headers: this.headers}).toPromise().then(data =>{
      permiso.forEach(element => {
        console.log(element);
        element.id_usuario=data;
        element.token=usuario.token;
        this.http.post(this.endpopint+'permiso',element ,{headers: this.headers}).toPromise();

      });

    });
    return id;
  }
  put(usuario:Usr, permiso:Permiso[]){
    usuario.token=this.cookie.getCookie();
    let id= this.http.put<number>(this.endpopint+'usr/'+ usuario.id,usuario ,{headers: this.headers}).toPromise().then(data =>{
      permiso.forEach(element => {
        console.log(element);
        element.id_usuario=data;
        element.token=this.cookie.getCookie();
        if(element.id===0 && element.estado===true){
          element.token=usuario.token;
          this.http.post(this.endpopint+'permiso',element ,{headers: this.headers}).toPromise();
        }else{
          if(element.estado===false){
            element.token=usuario.token;
            this.http.delete(this.endpopint+'permiso/'+element.id ,{headers: this.headers}).toPromise();
          }

        }



      });

    });
    return id;
  }
}
